import { useAppSelector } from "../../../src/store/storeTypes";
import { MenuProduct } from "../../../src/types/MenuTypes";
import Cross from "../shared/Cross";
import { Tags } from "../Tags";
import { useBreakPoint } from "../../../src/hooks/useBreakPoint";
import DietaryIcons from "../DietaryIcons";
import { getPeppers } from "../../../src/features/menu/components/CustomiseCard";

interface PizzaDescriptionModalProps {
    onClose: () => void;
    inApp: boolean;
    screenWidth: number;
    item: MenuProduct;
}

const PizzaDescriptionModal = ({ onClose, inApp, screenWidth, item }: PizzaDescriptionModalProps) => {
    const showCalories = useAppSelector(state => state.menu.showCalories);
    const currentTier = useAppSelector(state => state.session?.customer?.loyalty?.customer?.currentTier?.name);
    const loyaltySchemeVersion = useAppSelector(state => state.session?.customer?.loyalty?.customer?.loyaltySchemeVersion);
    
    const isSmallScreen = useBreakPoint(screenWidth, 550);

    const handleClose = (e: MouseEvent) => {
        e.stopPropagation();
        onClose()
    };

    return (
        <div className={`pizza-desc-modal`}>
            {isSmallScreen || inApp ?
                <></> :
                <Cross onClick={(e: MouseEvent) => handleClose(e)} absolute rightPosition={16} topPosition={16} closeWhiteCross={true} />
            }
            <img className={'pizza-desc-image'} src={item?.imageUrl} alt='food item' />
            <div className={'pizza-desc-info'}>
                {!isSmallScreen && <Tags
                    item={item}
                    currentTier={currentTier}
                    showLocked={false}
                    excludeChildTags={true}
                    loyaltySchemeVersion={loyaltySchemeVersion}
                    wrapperClass={'all-tags-wrapper '}
                />}
                <h1 className={'customise-header-item-name'}>{item?.name && item?.name.replace(/NEW! /g, '').split('(')[0]}</h1>
                <div className={'pizza-desc-cals-diet-prefs'}>
                    {showCalories && item?.calories && <span style={{ opacity: 0.8 }}>{`${item?.calories}`}</span>}
                    {item?.dietPreferences && <DietaryIcons icons={item?.dietPreferences} />}
                    {item?.uiTags && getPeppers(item?.uiTags)}
                </div>
                {item?.description && <p style={{ textAlign: 'left' }}>{item?.description}</p>}
            </div>
        </div>
    )
}

export default PizzaDescriptionModal;
